<template>
    <div class="container">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'ContentContainer'
}
</script>

<style scoped lang="scss">
    .container {
        width: 100%;
        max-width: $max-content-width + (2 * $container-padding);
        padding: 0 $container-padding;
        margin: 0 auto;
    }
</style>